import type { ForceLogoProps } from "../types";

/**
 * ITのForceロゴアイコン
 */
export function ForceLogoIT({ size = 36, ...props }: ForceLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5977 23.7109V12.2891H14.0195V23.7109H11.5977Z"
        fill="#1874A1"
      />
      <path
        d="M21.3008 23.7109H18.8789V14.3047H15.7773V12.2891H24.4023V14.3047H21.3008V23.7109Z"
        fill="#1874A1"
      />
    </svg>
  );
}
